module.exports = require("path");


/*****************
 ** WEBPACK FOOTER
 ** external "path"
 ** module id = 9
 ** module chunks = 0
 **/